import React, { useState } from "react";
import { MdOutlineContentCopy } from "react-icons/md";
import { BsPencil } from "react-icons/bs";
import { FiPlus } from "react-icons/fi";
import nigeriaFlag from '../../assets/img/flag/nigeria-flag.png'

const BankInfo = ({ userDetails }) => {
    const bankDetails = {
        accountName: userDetails?.bank_account[0]?.account_name,
        accountNumber: userDetails?.bank_account[0]?.account_number,
        bankName: "Cardplot Account",
    };
    const [copied, setCopied] = useState(false);

    const handleCopyAccountNumber = () => {
        navigator.clipboard.writeText(bankDetails.accountNumber);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };

  return (
    <section className="bankInfo-content container">
      <div className="row">
        <div className="p-4 py-5 rounded shadow-sm">
          <div className="bankInfo-heading d-flex flex-wrap justify-content-between align-items-center mb-3">
            <div>
              <h5 className="">Link Bank Account</h5>
              <p className="t">Connect a bank account to your Cardplot wallet</p>
            </div>
            <button className="btn addBank-btn d-flex align-items-center gap-2">
                <FiPlus size={24} /> <span>Add Bank Account</span>
            </button>
          </div>

          <div className="country-details d-flex align-items-center my-4">
            <img src={nigeriaFlag} alt="NGN Flag" className="me-2" width="25px" />
            <span className="">NGN (Nigerian Naira)</span>
          </div>

          <div className="row justify-content-between">
            <div className="bank-details col-11">
                <div className="d-flex flex-wrap justify-content-between align-items-center position-relative">
                    <div>
                        <h6 className="mb-1">Account Name:</h6>
                        <p className="">{bankDetails.accountName}</p>
                    </div>
                    <div className="">
                        <h6 className="mb-1 me-2">Account Number:</h6>
                        <p className=" me-2">{bankDetails.accountNumber}</p>
                    </div>

                    <div className="copy-icon">
                        <div className="position-relative">
                            <MdOutlineContentCopy role="button" size={20} onClick={handleCopyAccountNumber} />
                            {/* Tooltip */}
                            {copied && (
                                <div className="copy-tooltip text-white p-2 rounded small">
                                    Copied!
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <h6 className="mb-1">Bank Name:</h6>
                <p className="">{bankDetails.bankName}</p>
            </div>

            <div className="text-end col-1">
                <BsPencil role="button" size={20} className="" />
            </div>
          </div>
        </div>
        <hr style={{ width: "98%", margin: "auto", height: "2px" }} />
      </div>
    </section>
  );
};

export default BankInfo;
